.wrapper {
  position: absolute;
  top: 40px;
  right: 16px;
  left: 16px;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.container {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 600px;
  padding: 12px 16px;
  border-radius: 100px;
  background: var(--color-white);
  box-shadow: 0 2px 8px var(--color-shadow-1);
  gap: 12px;
  pointer-events: auto;
}

.input {
  flex: 1;
  min-width: 0;
  border: none;
  font-size: var(--font-size-lg);
  background: transparent;
  color: var(--color-text-0);
  outline: none;
}

.input::placeholder {
  color: var(--color-text-3);
}

.searchButton {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-text-3);
  cursor: pointer;
  transition: color 0.2s ease;
}

.searchButton:hover {
  color: var(--color-primary);
}

.searchIcon {
  width: 24px;
  height: 24px;
}

.textButton .searchButtonText {
  display: flex;
  width: 120px;
  min-height: 56px;
  border-radius: var(--border-radius-lg);
}

.textButton .searchIcon {
  width: 20px;
  height: 20px;
  color: var(--color-primary);
}

@media (--view-sm) {
  .wrapper {
    right: 0;
    left: 0;
  }

  .container {
    padding: 16px 24px;
  }

  .input {
    font-size: var(--font-size-lg);
  }

  .searchIcon {
    width: 28px;
    height: 28px;
  }

  .textButton .searchIcon {
    width: 20px;
    height: 20px;
  }
}
